import React from 'react';

import { Grid } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import {
  loadActions,
  loadActionsBy,
} from 'scenes/SmartRules/sources/actionsLog';

import { FILTER_ACTIONS, FILTER_ACTIONS_BY, FILTER_PERIOD } from './constants';
import { actionsLogSchema } from './schema';

export const ActionsLogFilter = withForm({
  validationSchema: actionsLogSchema,
})(({ values, submitForm }) => {
  const handleChange = React.useCallback(() => {
    submitForm(values);
  }, [values, submitForm]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <FormField.MultiSelect
          label={'Actions'}
          name={FILTER_ACTIONS}
          source={loadActions}
          onChange={handleChange}
          lazy={true}
          padding={'0'}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.Select
          label={'Actions by'}
          name={FILTER_ACTIONS_BY}
          source={loadActionsBy}
          onChange={handleChange}
          withDeselectButton={true}
          lazy={true}
          padding={'0'}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.DateRangePicker
          label={'Period'}
          name={FILTER_PERIOD}
          placeholder={'Select period'}
          onChange={handleChange}
          padding={'0'}
        />
      </Grid>
    </Grid>
  );
});
